module.exports = __webpack_public_path__ + "images/emoji/busts_in_silhouette.c162ae8179eac5df2480.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/busts_in_silhouette.png
// module id = qXv1
// module chunks = 1